module.exports = require("@mui/x-tree-view-pro/RichTreeViewPro");